module.exports = __webpack_public_path__ + "static/sameer-694e8be6335526809cab0cc089662f5d.jpeg";